import axiosInstance from './AxiosConfig';

export const fetchCategoriasAPI = async (idFederacion) => {
  try {
    const response = await axiosInstance.get(`/api/categorias?id_federacion=${idFederacion}`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las categorías:", error);
    throw error;
  }
};

// Nueva función para obtener categorías por ID de federación

export const fetchCategoriasByIdFederationAPI = async (federationId) => {
  try {
    const response = await axiosInstance.get(`/api/categorias/federacion/${federationId}`);
    //console.log('response.data', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al obtener el torneo:', error);
    throw error;
  }
};

export const createCategory = async (newCategory) => {
  try {
    const response = await axiosInstance.post('/api/categorias', newCategory);
    return response.data;
  } catch (error) {
    console.error('Error al crear la categoría:', error);
    throw error;
  }
};

export const deleteCategory = async (idCategoria) => {
  try {
    const response = await axiosInstance.delete(`/api/categorias/${idCategoria}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar la categoría:', error);
    throw error;
  }
};

export const updateCategory = async (idCategoria, data) => {
  try {
    const response = await axiosInstance.put(`/api/categorias/${idCategoria}`, data);
    return response.data;
  } catch (error) {
    console.error('Error al modificar la categoría:', error);
    throw error;
  }
};